import { combineEpics } from 'redux-observable';
import { addToWishlistEpic, removeFromWishlistEpic } from '@spa/shared/store/epics/profile';
import { generateGalleryGridEpic, requestPriceDetails, requestOfferViews } from './offer';
import { track } from '@spa/shared/store/epics/tracking';
var epics = combineEpics(generateGalleryGridEpic, addToWishlistEpic, removeFromWishlistEpic, requestPriceDetails, requestOfferViews, track);
export default epics;